import { render, staticRenderFns } from "./ContactDisplay.vue?vue&type=template&id=9fcde55a&scoped=true&"
import script from "./ContactDisplay.vue?vue&type=script&lang=js&"
export * from "./ContactDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcde55a",
  null
  
)

export default component.exports